/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TutorialsService } from '@app/core/services';
import { TutorialDialogData } from './types';

@Component({
  templateUrl: './dialog-tutorials.component.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
})
export class DialogTutorialsComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TutorialDialogData,
    private dialogRef: MatDialogRef<DialogTutorialsComponent>,
    private TutorialsService: TutorialsService,
  ) {}

  public openTutorial(id?: string) {
    this.dialogRef.close();
    if (id) this.TutorialsService.openTutorial(id);
  }
}
